import { Button, Checkbox, DialogActions, DialogTitle, FormControlLabel } from "@mui/material"
import { useDialog } from "../libs/dialog/DialogProvider"
import { createRef } from "react"
import PassApi from "../data/PassApi"

export default function LogoutDlg(){
    const checkDelete = createRef<HTMLInputElement>()
    const {closeDialog} = useDialog()
    const onConfirm = () => {
        closeDialog()
        if (checkDelete.current?.checked) PassApi.i.clear()
        PassApi.i.logout()
    }
    return <>
        <DialogTitle>Logout</DialogTitle>
        <div className="content">
            <p>Delete local storage after logout?</p>
            <FormControlLabel control={ <Checkbox/>} label="DELETE" inputRef={checkDelete}/> 
        </div>
        <DialogActions>
            <Button variant="outlined" onClick={closeDialog}>CANCEL</Button>
            <Button variant="contained" color="primary" onClick={onConfirm}>OKAY</Button>
        </DialogActions>
    </>
}